var _circle, _circle2, _g, _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EBEBF7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2987_3046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EBEBF7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2987_3046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44L9 31.5L14 30.5L15 6L41.5 29L36.5 36L22 44Z",
    fill: "#79B6FC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.177 6.15796C15.177 6.35171 15.1476 6.48198 15.1024 6.57121C15.0591 6.65648 14.9971 6.71324 14.9105 6.75382C14.8197 6.7964 14.6999 6.8219 14.5438 6.83549C14.3882 6.84905 14.2083 6.85 14 6.85C13.7914 6.85 13.6186 6.84903 13.4733 6.83557C13.3275 6.82206 13.2235 6.79694 13.1482 6.75706C13.0781 6.71996 13.0266 6.66699 12.99 6.5805C12.9512 6.4889 12.9273 6.3554 12.9273 6.15796C12.9273 5.76441 13.0201 5.52427 13.1778 5.37845C13.3381 5.23021 13.5968 5.15 13.9959 5.15C14.3943 5.15 14.6867 5.22993 14.8776 5.38481C15.0624 5.53471 15.177 5.77542 15.177 6.15796Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8939 11.6061L32.6379 16.35H14.15V6.65H32.6379L27.8939 11.3939L27.7879 11.5L27.8939 11.6061Z",
    fill: "#F54756",
    stroke: "black",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.85 31C19.85 31.5954 19.3122 32.1834 18.327 32.6312C17.3553 33.0729 16.0024 33.35 14.5 33.35C12.9976 33.35 11.6447 33.0729 10.673 32.6312C9.68775 32.1834 9.15 31.5954 9.15 31C9.15 30.4046 9.68775 29.8166 10.673 29.3688C11.6447 28.9271 12.9976 28.65 14.5 28.65C16.0024 28.65 17.3553 28.9271 18.327 29.3688C19.3122 29.8166 19.85 30.4046 19.85 31Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.85 30C19.85 30.5954 19.3122 31.1834 18.327 31.6312C17.3553 32.0729 16.0024 32.35 14.5 32.35C12.9976 32.35 11.6447 32.0729 10.673 31.6312C9.68775 31.1834 9.15 30.5954 9.15 30C9.15 29.4046 9.68775 28.8166 10.673 28.3688C11.6447 27.9271 12.9976 27.65 14.5 27.65C16.0024 27.65 17.3553 27.9271 18.327 28.3688C19.3122 28.8166 19.85 29.4046 19.85 30Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.15,
    y: 0.15,
    width: 1.7,
    height: 24.7,
    transform: "matrix(-1 0 0 1 14.7 6.5)",
    fill: "#DD404D",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNation);
export default __webpack_public_path__ + "static/media/Nation.58126cc48a1c6207b48b741a1c5dffba.svg";
export { ForwardRef as ReactComponent };